import { gql } from "@apollo/client";

export const GET_AJUSTE_BY_DETALLE = gql`
    query ajusteByDetalle($idLiquidacionProfesionalDetalle: Int!) {
        ajusteByDetalle(idLiquidacionProfesionalDetalle: $idLiquidacionProfesionalDetalle) {
            idAjusteLiquidacion
            idMotivoAjuste
            ajuste
            observacionAjuste
            idUsuarioSolicitante
        }
    }
`;